const CommissionType = Object.freeze({
  Percent: 'PERCENT',
  Flat: 'FLAT',
});

export default CommissionType;
